/**
 * Get formatted string price back from float price
 */
export function useFormatPrice(price: number | undefined): string {
    if (typeof price !== 'number') {
        return '';
    }

    const formatPrice: string = new Intl.NumberFormat('de-DE', {
        style: 'currency',
        currency: 'EUR'
    }).format(price);

    return formatPrice;
}
